/** Petits utilitaires de construction de texte SVG, partagés par pdfPageSvg.ts. */

export function escapeXml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}

let measureCtx: CanvasRenderingContext2D | null = null;
function getMeasureCtx(): CanvasRenderingContext2D {
  if (!measureCtx) {
    measureCtx = document.createElement('canvas').getContext('2d') as CanvasRenderingContext2D;
  }
  return measureCtx;
}

/** Tronque `text` avec une ellipse pour qu'il tienne dans `maxWidth` px, mesuré via un <canvas> hors écran (même technique que le navigateur utilise pour l'affichage réel). */
export function truncateToWidth(text: string, maxWidth: number, font: string): string {
  if (!text) return text;
  const ctx = getMeasureCtx();
  ctx.font = font;
  if (ctx.measureText(text).width <= maxWidth) return text;
  const ellipsis = '…';
  if (ctx.measureText(ellipsis).width > maxWidth) return '';
  let lo = 0;
  let hi = text.length;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (ctx.measureText(text.slice(0, mid) + ellipsis).width <= maxWidth) lo = mid;
    else hi = mid - 1;
  }
  return lo === 0 ? ellipsis : text.slice(0, lo) + ellipsis;
}
